import { Col, Flex, Layout, Row, Space, Tag, Typography } from 'antd'
import { Outlet } from 'react-router-dom'
import MainHeader from './components/MainHeader'
import { LayoutFooter } from './components/LayoutFooter'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { LegalMenu } from './components/LegalMenu'

const { Content } = Layout
const { Text } = Typography

export const LayoutLegal: React.FC = () => {
  return (
    <Layout>
      <Layout style={{ minHeight: '100vh', marginTop: 64 }}>
        <Content>
          <Row className="container-row">
            <Col span={24} className="px-4">
              <Space
                className="space-between align-items-center w-full"
                style={{ marginBottom: 10 }}
              >
                <Link to="/">
                  <Flex gap={15} align="center">
                    <ArrowLeftOutlined />
                    <img
                      src="/assets/images/logos/regular/purple.png"
                      height={50}
                    />
                  </Flex>
                </Link>
                <LegalMenu />
              </Space>
            </Col>
            <Col span={24} className="px-4">
              <Outlet />
            </Col>
          </Row>
        </Content>
      </Layout>
    </Layout>
  )
}
